module.exports = __webpack_public_path__ + "img/european-union.38159e27.png";